import { useRouter } from "next/router";

import Container from "../../components/blogComponents/container";
import MoreStories from "../../components/blogComponents/more-stories";
import HeroPost from "../../components/blogComponents/hero-post";
import Intro from "../../components/blogComponents/intro";
// import Layout from "../../components/blogComponents/layout";
import { getAllPosts } from "../../lib/api";
import Head from "next/head";
import { CMS_NAME } from "../../lib/constants";
import ZoraPagination from "../../components/atoms/Pagination";
import { useMemo, useState } from "react";
import { Box } from "@chakra-ui/react";
import { NextSeo } from "next-seo";
import Post from "../../components/blogComponents/post/post";
import styles from "../../styles/blogs.module.scss";
import Layout from "../../components/templates/Layout";
import HeroBlog from "../../components/blogComponents/heroBlog/heroBlog";
import UiButton from "../../components/atoms/UiButton";

import { useWindowSize } from "../../hooks/useWindowSize";
// /** @param {import('next').InferGetStaticPropsType<typeof getStaticProps> } props */
export default function Index({ allPosts }) {
  // pagination
  const [limit, setLimit] = useState(11);
  // const [currentPage, setCurrentPage] = useState(1);
  // const currentTableData = useMemo(() => {
  //   const firstPageIndex = (currentPage - 1) * PageSize;
  //   const lastPageIndex = firstPageIndex + PageSize;
  //   return allPosts.slice(firstPageIndex, lastPageIndex);
  // }, [currentPage]);

  const router = useRouter();
  const heroPost = allPosts[0];
  const morePosts = allPosts.slice(1);
  const path = router.pathname.split("/");

  const showMoreItems = () => {
    setLimit((prevValue) => prevValue + 6);
  };
  // debugger;
  return (
    <>
      <Layout>
        <NextSeo
          title="The CoverClap Blog"
          description="CoverClap blog for beauty solopreneurs. Learn tips, stratégies and beauty trends to market your business in Montreal."
          openGraph={{
            url: "https://coverclap.com/blog",
            type: "article",
            siteName: "CoverClap",
            images: [
              {
                url: "https://coverclap.com/new-ui/images/coverclap.png",
                width: 1200,
                height: 1076,
              },
            ],
          }}
        />
        <Container>
          <Intro />
          <HeroBlog allPosts={allPosts} />

          <section className={styles.posts}>
            <>
              {useWindowSize().width > 1199 ? (
                <>
                  {allPosts &&
                    allPosts?.slice(5, limit)?.map((post, i) => {
                      return (
                        <Post
                          key={i}
                          category={post.category}
                          title={post.title}
                          coverImage={post.coverImage}
                          slug={post.slug}
                          excerpt={post.excerpt}
                          description={post.description}
                        />
                      );
                    })}{" "}
                </>
              ) : (
                <>
                  {allPosts &&
                    allPosts?.slice(4, limit)?.map((post, i) => {
                      return (
                        <Post
                          key={i}
                          category={post.category}
                          title={post.title}
                          coverImage={post.coverImage}
                          slug={post.slug}
                          excerpt={post.excerpt}
                          description={post.description}
                        />
                      );
                    })}{" "}
                </>
              )}
            </>

            <div className={styles.view__more__wrapper}>
              {allPosts?.length > 10 && (
                <button className={styles.view__more} onClick={showMoreItems}>
                  View More
                </button>
              )}
            </div>
            {/* {morePosts.length > 0 && <MoreStories posts={morePosts} />} */}
          </section>
        </Container>
      </Layout>
    </>
  );
}

export async function getServerSideProps({ query }) {
  const category = query && query.category ? query.category : undefined;

  const allPosts = getAllPosts(
    [
      "title",
      "date",
      "slug",
      "author",
      "coverImage",
      "excerpt",
      "description",
      "category",
    ],
    category
  );
  return {
    props: { allPosts },
  };
}
